export enum NotesEntryLabelsEnum {
  SUBJECT = 'Subject',
  NOTE_TYPE = 'Note Type',
  NOTE_DESCRIPTION = 'Note Description',
}
